import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table view for wallets.
 * @extends JetView
 */
export default class tableWalletsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            height: screen.width < 820 ? 400 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'Action', // Column ID for actions
                                    header: '', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip for the column
                                    template: function (obj) {
                                        // Template function for rendering action icons
                                        if (obj.State == 'I') {
                                            return "<span class='webix_icon wxi-close approve'></span>"; // Icon for inactive state
                                        } else {
                                            if (obj.State == 'A') {
                                                return "<span class='webix_icon wxi-close torefuse'></span>"; // Icon for active state
                                            } else {
                                                return ''; // No icon for other states
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: _('ID'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID for Name
                                    header: _('Nombre'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID for State
                                    header: _('Estado'), // Column header
                                    editor: 'combo', // Editor type for the column
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') }, // Active option
                                        { id: 'I', value: _('Inactivado') }, // Inactive option
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                approve: function (euv, id) {
                                    // Handler for approve action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog for activating wallet
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Activar Billetera?'),
                                        ok: _('Activar Billetera'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item from the DataTable
                                                webix
                                                    .ajax() // AJAX request to activate wallet
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Wallets/ActivateWallet', // API endpoint
                                                        '{"Id":' + item.Id + '}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error handler
                                                                webix.message('Error! '); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success handler
                                                                var resp = JSON.parse(text); // Parse response
                                                                if (!resp.HasError) {
                                                                    // Check for errors
                                                                    item.State = 'A'; // Update item state
                                                                    webix.message(_('Billetera Activada')); // Show success message
                                                                    vthis.$$('datatable').clearAll(); // Clear DataTable
                                                                    vthis.$$('datatable').load(url); // Reload DataTable
                                                                } else {
                                                                    webix.alert({
                                                                        // Show error alert
                                                                        type: 'alert-error',
                                                                        title: 'Error',
                                                                        text: _('Error! '),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                torefuse: function (euv, id) {
                                    // Handler for torefuse action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog for inactivating wallet
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Inactivar Billetera?'),
                                        ok: _('Inactivar Billetera'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item from the DataTable
                                                webix
                                                    .ajax() // AJAX request to inactivate wallet
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Wallets/InactivateWallet', // API endpoint
                                                        '{"Id":' + item.Id + '}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error handler
                                                                webix.message('Error! '); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success handler
                                                                var resp = JSON.parse(text); // Parse response
                                                                if (!resp.HasError) {
                                                                    // Check for errors
                                                                    item.State = 'I'; // Update item state
                                                                    webix.message(_('Billetera Inactivada')); // Show success message
                                                                    vthis.$$('datatable').clearAll(); // Clear DataTable
                                                                    vthis.$$('datatable').load(url); // Reload DataTable
                                                                } else {
                                                                    webix.alert({
                                                                        // Show error alert
                                                                        type: 'alert-error',
                                                                        title: 'Error',
                                                                        text: _('Error! '),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            ready: function () {
                                // Event handler for when the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show overlay message
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Set data fetch settings
                            pager: 'pagerA', // ID for the pager component
                            url: devConfig.geturlApi() + 'es/Wallets/GetWallets', // API endpoint for loading wallets
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // Store the DataTable URL
        var filter = ''; // Initialize filter string
        this.on(this.app, 'wallets:filter', (filterData) => {
            // Event listener for filtering wallets
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filter values
                    if (object[i][0] == 'CreatedLocalDate') {
                        // Handle CreatedLocalDate filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            // Handle ModifiedLocalDate filter
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to filter string
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to filter string
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filter values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format dateFrom string
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format dateTo string
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear DataTable
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for after sorting
            grid.load(
                // Load sorted data
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir,
            );
        });
    }
}

// FILE DOCUMENTED
